import { memo, useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { getAppInfoData, handleKeyDownOnDiv,handleOpenMode } from '../../utils/global_functions';
import { APP_INFO_PARAMS, HAMBURGER_LIST, LINK_OPEN_MODES } from '../../utils/global_variables';
import {  getbrokerInformation, getExchangeTimings } from '../../redux/actions/appInfo';

const Footer = (props) => {
  const aboutUs = useSelector(state => state?.appInfo?.aboutUs);
  const disclaimer = useSelector(state => state?.appInfo?.disclaimer);
  const dispatch = useDispatch();
  const aboutusInfo = getAppInfoData(APP_INFO_PARAMS.APP_ABOUTUS_URL);
  const disclaimerInfo = getAppInfoData(APP_INFO_PARAMS.APP_DISCLAIMER_MODE);

  

  const handleAboutUs = () => {
    const hasAboutUsData =(typeof aboutUs === "string" && aboutUs.trim().length > 0) || (Array.isArray(aboutUs) && aboutUs.length > 0);
        if (hasAboutUsData) {
      dispatch(handleModal([{ "ABOUT_US_MODAL": true }]));
    }
    else {
      handleOpenMode(aboutusInfo);
    }
  };

  const handleDisclaimer = () => {
    const hasDisclaimerData =
      (typeof disclaimer === "string" && disclaimer.trim().length > 0) ||
      (Array.isArray(disclaimer) && disclaimer.length > 0);
    if (hasDisclaimerData) {
      dispatch(handleModal([{ "DISCLAIMER_MODAL": true }]));
    }
    else {
      handleOpenMode(disclaimerInfo);
    }
  };

  const handleExchangeTiming = () => {
    dispatch(getExchangeTimings()); //Ameersha Moved api call into onClick of call of this function instead on component mounting in useEffect
    dispatch(handleModal([{ "EXCHANGE_TIMING_MODAL": true }]));
  };

  const handleMembershipDetails = () => {
    dispatch(getbrokerInformation()); //Ameersha Moved api call into onClick of call of this function instead on component mounting in useEffect
    dispatch(handleModal([{ "MEMBERSHIP_DETAILS_MODAL": true }]));
  };


  const handleExchangeLinks = () => {
    dispatch(handleModal([{ 'SSO_LINK_MODAL': true }]));
    dispatch(handleModalData({ header: "Links", data: [], name: HAMBURGER_LIST.EXCHANGE_LINKS, id: 306, testid: "exchange-links-modal" }));
  };

  return (
    <div className={props.className}>
      <Container data-testid='login-footer' fluid className='p-0'>
        <Row className='g-0'>
          <Col className='footer-link'>
              <a data-testid='login-footer-exchangetimings-link' className='font-medium font-size1 focus position-relative text-nowrap' href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleExchangeTiming}>Exchange Timings</a>
              <a data-testid='login-footer-aboutus-link' className='font-medium font-size1 focus position-relative text-nowrap' href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleAboutUs}>About Us</a>
              <a data-testid='login-footer-membershipdetails-link' className='font-medium font-size1 focus position-relative text-nowrap' href='#' onClick={() => handleMembershipDetails()}>Membership Details</a>
              <a data-testid='login-footer-links-link' className='font-medium font-size1 focus position-relative text-nowrap' href='#' onClick={handleExchangeLinks}>Links</a>
              <a data-testid='login-footer-disclaimer-link' className='font-medium font-size1 focus position-relative text-nowrap' href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleDisclaimer}>Disclaimer</a>
          </Col>
        </Row>
        <Row data-testid='login-footer-copyright-row' className='g-0 my-2'>
          <Col className='font-regular font-size1 color-subtext'>
            Breeze v2.0.0.0 Powered by Synapsewave Innovations Pvt. Ltd.
          </Col>
        </Row>
      </Container>
    </div>

  );
};
export default memo(Footer);